// Generated by Copilot
import { Icon } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { ChooseScenarios } from "@/components/pages_logged_in/program/components/set-components/ChooseScenarios";
import { ChooseSpecialty } from "@/components/pages_logged_in/program/components/set-components/ChooseSpecialty";
import { ChooseType } from "@/components/pages_logged_in/program/components/set-components/ChooseType";
import { Coaches } from "@/components/pages_logged_in/program/components/set-components/Coaches";
import { Completed } from "@/components/pages_logged_in/program/components/set-components/Completed";
import { Configure } from "@/components/pages_logged_in/program/components/set-components/Configure";
import { Customize } from "@/components/pages_logged_in/program/components/set-components/Customize";
import { Define } from "@/components/pages_logged_in/program/components/set-components/Define";
import { Journey } from "@/components/pages_logged_in/program/components/set-components/Journey";
import { Template } from "@/components/pages_logged_in/program/components/set-components/Template";
import { SUBTEXT_COLOR } from "@/css/constants";
import { ComponentTypeEnum } from "@/graphql";
import { ComponentTabProps } from "@/types/programs";

interface TabConfig {
  key: number;
  label: React.ReactNode | null;
  Component: React.ComponentType<ComponentTabProps>;
  completed: boolean;
  icon: React.ReactNode | null;
}

const createTabIcon = (color = "#E2E2E2") => (
  <Icon
    icon="full-circle"
    size={14}
    style={{ marginRight: 10 }}
    color={color}
  />
);

export const SURVEY_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Template</Box>,
    Component: Template,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: <Box color={SUBTEXT_COLOR}>Customize</Box>,
    Component: Customize,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 3,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 4,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const ACTION_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Define</Box>,
    Component: Define,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 3,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const AI_ROLEPLAY_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Scenarios</Box>,
    Component: ChooseScenarios,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 3,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const ANNOUNCEMENT_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const VIDEO_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const ARTICLE_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const GROUP_MEETING_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Configure</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const ONE_ONE_SESSION_TABS: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
  {
    key: 1,
    label: <Box color={SUBTEXT_COLOR}>Specialty</Box>,
    Component: ChooseSpecialty,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 2,
    label: <Box color={SUBTEXT_COLOR}>Basics</Box>,
    Component: Configure,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 3,
    label: <Box color={SUBTEXT_COLOR}>Journey</Box>,
    Component: Journey,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 4,
    label: <Box color={SUBTEXT_COLOR}>Coaches</Box>,
    Component: Coaches,
    completed: false,
    icon: createTabIcon(),
  },
  {
    key: 5,
    label: null,
    Component: Completed,
    completed: false,
    icon: null,
  },
];

export const TAB_SETTING_DEFAULT: TabConfig[] = [
  {
    key: 0,
    label: <Box color={SUBTEXT_COLOR}>Choose Type</Box>,
    Component: ChooseType,
    completed: true,
    icon: createTabIcon(),
  },
];

export const TAB_SETTINGS_BY_TYPE: Partial<
  Record<ComponentTypeEnum, TabConfig[]>
> = {
  [ComponentTypeEnum.Survey]: SURVEY_TABS,
  [ComponentTypeEnum.ActionItem]: ACTION_TABS,
  [ComponentTypeEnum.Announcement]: ANNOUNCEMENT_TABS,
  [ComponentTypeEnum.AiRoleplay]: AI_ROLEPLAY_TABS,
  [ComponentTypeEnum.Video]: VIDEO_TABS,
  [ComponentTypeEnum.Article]: ARTICLE_TABS,
  [ComponentTypeEnum.GroupMeeting]: GROUP_MEETING_TABS,
  [ComponentTypeEnum.OneOneCoachingMaster]: ONE_ONE_SESSION_TABS,
};

export const ConfigureTabIndexByType: Partial<
  Record<ComponentTypeEnum, number[]>
> = {
  [ComponentTypeEnum.Survey]: [3],
  [ComponentTypeEnum.ActionItem]: [2],
  [ComponentTypeEnum.Video]: [2],
  [ComponentTypeEnum.Article]: [2],
  [ComponentTypeEnum.Announcement]: [1],
  [ComponentTypeEnum.AiRoleplay]: [2],
  [ComponentTypeEnum.GroupMeeting]: [1],
  [ComponentTypeEnum.OneOneCoachingMaster]: [2, 3, 4],
};

export const ICON_TICK_CIRCLE = (
  <Icon
    icon="tick-circle"
    size={14}
    style={{ marginRight: 10 }}
    color="#0d8050"
  />
);

export const ICON_FULL_CIRCLE = (
  <Icon
    icon="full-circle"
    size={14}
    style={{ marginRight: 10 }}
    color="#0d8050"
  />
);

export const getComponentTabList = (
  type?: ComponentTypeEnum | null,
  componentId?: string,
): TabConfig[] => {
  if (!type) return TAB_SETTING_DEFAULT;

  let tabList = TAB_SETTINGS_BY_TYPE[type] || TAB_SETTING_DEFAULT;

  if (componentId) {
    tabList = tabList.slice(1);
  }

  return tabList;
};
